// extracted by mini-css-extract-plugin
module.exports = {"entryPair":"EntryPair_entryPair__2FaCd"};